module.exports = __webpack_public_path__ + "static/img/1.9ad4d46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/1.png
// module id = +Ddx
// module chunks = 0